import { Component, computed, input } from '@angular/core';
import { NotificationLayoutComponent } from '../../notification-detail-layout/notification-detail-layout.component';
import { NotificationStep, TeacherNotification } from '../../../core/models/notification.model';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'wf-poor-usage-foil-notification',
  imports: [
    NotificationLayoutComponent
  ],
  template: `
    <wf-notification-layout
      headerTitle="⏰ Student(s) are spending extra time on a task"
      [preambles]="[{
        text: 'The student(s) below completed are taking significantly longer than expected to complete a task in WordFlight. '
          + 'This could mean they’re finding the task difficult, unsure of the directions, or not fully engaged. '
          + 'A quick check-in will help you get to the bottom of it.'
      }]"
      [steps]="steps"
      [ids]="ids()"
      ctaLabel="Open Unit Detail report"
      ctaRoute="/reports/system/unit-detail"
    >
      <table table class="table-wrap">
        <tr>
          <th class="th">Student</th>
        </tr>
        @for (notification of data(); track notification.alertID) {
          <tr>
            <td class="td">{{ notification.studentName }}</td>
          </tr>
        }
      </table>
    </wf-notification-layout>
  `,
  standalone: true,
})
export class PoorUsageFoilNotificationComponent {
  private readonly studentAppLink = environment.studentSiteURL;
  readonly data = input.required<TeacherNotification[] | null>();
  readonly ids = computed(() => {
    const notifications = this.data() ?? [];

    return { alerts: notifications.map(notification => notification.alertID) };
  });
  readonly steps: NotificationStep[] = [
    {
      title: 'Check in with the student',
      body: 'Ask them how it’s going. Sometimes a brief conversation is all it takes to get a student back on track.',
    },
    {
      title: 'Review their responses in the Unit Detail report',
      body: 'Open the Unit Detail report and click the <b>Time</b> column header to sort tasks by time '
        + '(least to most, or most to least). Click the <b>+</b> next to the flagged task to see exactly how the student responded to each trial.',
    },
    {
      title: 'Try the task together',
      body: 'Log in to the <a href="' + this.studentAppLink + '" target="_blank">student demo program</a> and work through the task side-by-side. '
        + 'Use the Unit Detail report to find the Unit, Level, and Word List. Check the Group Summary report for their Instructional Zone if needed.'
    },
    {
      title: 'Access small group resources if needed',
      body: 'If the student needs one-on-one concept support, visit '
        + '<a href="#" data-route="/small-group/system/all/model-lessons">Small Group Instruction</a> in the Management Site '
        + 'for lesson plans and targeted resources.',
      variant: 'green',
    }
  ];
}
